import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;

interface ShadowProps {
  width?: number;
}

const TopShadow = styled.div<ShadowProps>`
  position: absolute;
  height: 10px;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  margin-top: -10px;
  z-index: 1;
  width: ${({ width }) => `${width}px`};
`;
const BottomShadow = styled.div<ShadowProps>`
  height: 10px;
  z-index: 1;
  position: absolute;
  bottom: 48px;
  width: ${({ width }) => `${width}px`};
  box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.1);
`;

interface ScrollableDropShadowProps {
  displayBottomShadow?: boolean;
  children?: React.ReactNode;
  inert?: boolean;
}

const ScrollableDropShadow = ({ displayBottomShadow, children, inert }: ScrollableDropShadowProps) => {
  const [width, setWidth] = useState(0);
  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);

  const checkIfScrollable = () => {
    const ref = componentRef.current;
    if (ref) {
      if (ref.scrollHeight > ref.clientHeight) {
        setShowBottomShadow(true);
      } else {
        setShowBottomShadow(false);
      }
    }
  };
  useEffect(() => {
    if (componentRef.current) {
      setWidth(componentRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('click', checkIfScrollable);
    return () => document.removeEventListener('click', checkIfScrollable);
  }, []);

  // Check if component was scrolled
  const onScrollHandler = () => {
    const ref = componentRef.current;
    if (ref) {
      const didScroll = ref.scrollTop > 0;
      if (didScroll !== showTopShadow) {
        setShowTopShadow(didScroll);
      }

      const scrolledToBottom = ref.scrollHeight - ref.scrollTop - ref.clientHeight < 1;
      if (scrolledToBottom) {
        setShowBottomShadow(false);
      } else {
        setShowBottomShadow(true);
      }
    }
  };

  return (
    <Wrapper ref={componentRef} onScroll={onScrollHandler} data-testid="DropShadowWrapper" inert={inert}>
      {showTopShadow && <TopShadow width={width} data-testid="TopShadow" />}
      {children}
      {displayBottomShadow && showBottomShadow && <BottomShadow width={width} data-testid="BottomShadow" />}
    </Wrapper>
  );
};

export default ScrollableDropShadow;
